/**
 * aguardandoAlguemEntrar — "Aguardando alguém entrar…" (revisão final, N1, 25/10/2026)
 *
 * No grupo grande (mais de 10 pessoas) o servidor não chama ninguém: `toca_para` volta `0`, não há fim de 30 s e a
 * ligação espera alguém entrar pela faixa "Entrar". A janelinha mostra "Aguardando alguém entrar…" e o "tuuu" de
 * quem liga NÃO toca (não há ninguém tocando do outro lado). A janelinha e o `CallProvider` precisam responder a
 * mesma pergunta do mesmo jeito, por isso o predicado mora aqui, e não em um dos dois.
 *
 * Só vale depois da resposta do `/initiate` (`callSessionId` preenchido): do clique até lá ainda não se sabe
 * quantas pessoas tocam, e a conversa direta (`DM`) sempre toca.
 */
export function aguardandoAlguemEntrar(ligacao: {
  fase: string;
  callSessionId: string | null;
  tocaPara: number;
  roomType: string | null;
}): boolean {
  return (
    ligacao.fase === "chamando" &&
    ligacao.callSessionId !== null &&
    ligacao.tocaPara === 0 &&
    ligacao.roomType !== "DM"
  );
}
